// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { append, patch } from '@ngxs/store/operators';
import { ReceiptsService } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';
import {
  ClearScrollPositionTrafficList,
  GetTrafficList,
  GetTrafficListError,
  GetTrafficListSuccess,
  SetLastOpenedTrafficId,
  UpdateScrollPositionTrafficList
} from './traffic-list.actions';
import { TRAFFIC_LIST_STATE_DEFAULT, TrafficListStateModel } from './traffic-list.model';

@State({ name: 'TrafficList', defaults: TRAFFIC_LIST_STATE_DEFAULT })
@Injectable()
export class TrafficListState {

  constructor(private receiptService: ReceiptsService) {
  }

  @Selector()
  static loadReceiptListStatus(state: TrafficListStateModel): TrafficListStateModel['loadReceiptListStatus'] {
    return state.loadReceiptListStatus;
  }

  @Selector()
  static trafficList(state: TrafficListStateModel): TrafficListStateModel['trafficList'] {
    return state.trafficList;
  }

  @Selector()
  static lastOpenedDocId(state: TrafficListStateModel): TrafficListStateModel['lastOpenedDocId'] {
    return state.lastOpenedDocId;
  }

  @Action(GetTrafficList)
  getTrafficList(ctx: StateContext<TrafficListStateModel>, { filter, lazy }: GetTrafficList): void {
    if (lazy) {
      const next = ctx.getState().trafficList?.links?.next;
      if (next) {
        ctx.patchState({
          loadReceiptListStatus: PROGRESS_STATUSES.IN_PROGRESS
        });
        this.receiptService.getReceiptListLazy(next).subscribe({
          next: receipts => ctx.dispatch(new GetTrafficListSuccess(receipts, lazy)),
          error: error => ctx.dispatch(new GetTrafficListError(error))
        });
      }
    } else {
      ctx.patchState({
        loadReceiptListStatus: PROGRESS_STATUSES.IN_PROGRESS
      });
      this.receiptService.getReceipts(filter).subscribe({
        next: Traffics => ctx.dispatch(new GetTrafficListSuccess(Traffics, lazy)),
        error: error => ctx.dispatch(new GetTrafficListError(error))
      });
    }
  }

  @Action(GetTrafficListSuccess)
  getTrafficListSuccess(ctx: StateContext<TrafficListStateModel>, { receiptList, lazy }: GetTrafficListSuccess): void {
    ctx.patchState({
      loadReceiptListStatus: PROGRESS_STATUSES.SUCCESS
    });
    if (lazy) {
      ctx.setState(patch({
        trafficList: patch({
          data: append([...receiptList.data]),
          links: receiptList.links,
          meta: receiptList.meta
        })
      }));
    } else {
      ctx.patchState({
        trafficList: receiptList
      });

    }
  }

  @Action(GetTrafficListError)
  getReceiptListError(ctx: StateContext<TrafficListStateModel>, { error }: GetTrafficListError): void {
    ctx.patchState({
      loadReceiptListStatus: PROGRESS_STATUSES.FAIL
    });
  }

  @Action(ClearScrollPositionTrafficList)
  clearScrollPositionReceiptList(ctx: StateContext<TrafficListStateModel>): void {
    ctx.patchState({ scrollPosition: 0 });
  }

  @Action(UpdateScrollPositionTrafficList)
  updateScrollPosition(ctx: StateContext<TrafficListStateModel>, { position }: UpdateScrollPositionTrafficList): void {
    ctx.patchState({ scrollPosition: position });
  }

  @Action(SetLastOpenedTrafficId)
  setLastOpenedDocId(ctx: StateContext<TrafficListStateModel>, { trafficId }: SetLastOpenedTrafficId): void {
    ctx.patchState({ lastOpenedDocId: trafficId });
  }
}


